<template>
<div class="deneme">
      <div v-if="program_view">
            <div class="section-title">
                        PROGRAMS
            <router-link :to="{ name : 'sme.courses.create' }" tag="a" class="ml-2 button buttton-small small-button">
                <img src="../../assets/images/icons/solid/plus_white.svg" width="14" />
                    new
            </router-link>
            </div>
     
                <sme-table :table_body_data="courses" :table_headers="['ID','Program','In Class','Notes','Agencies','Modules','Created on','Actions']"
                :table_view="'courses'"
                :view="'sme'"
                @searchCourses="searchCourses"
                @showModalDuplicate="showModalDuplicate"
                @showModalDelete="showModalDelete"
                :pagination_existing_courses="pagination_existing_courses"
                @setPageExistingCourses="setPageExistingCourses"
                ></sme-table>
        </div>

        <div v-if="module_view">
            <div class="section-title">
            MODULES
             <router-link :to="{ name : 'sme.module.create' }" tag="a" class="ml-2 button buttton-small small-button">
                <img src="../../assets/images/icons/solid/plus_white.svg" width="14" />
                    new
            </router-link>
            </div>
            <table-view-course :table_headers="['ID','Module','Quiz','Notes','Lessons','Programs','Agencies','Created on','Actions']"
            :table_body_data="existing_modules" 
            :pagination_existing_modules="pagination_existing_modules"
            :show_add_module="false"
            :table_view="'module'"
            @showModalDuplicate="showModalDuplicate"
            @setPageExistingModules="setPageExistingModules"
            @keyUpSearchExistingModules="keyUpSearchExistingModules">
            </table-view-course>
        </div>
        <div v-if="lesson_view">
             <div class="section-title">
            LESSONS
            </div>
        	<table-view-course :table_headers="['ID','Lessons','Notes','Modules','Created on','']"
			:table_body_data="existing_lessons" 
			:pagination_existing_modules="pagination_existing_lessons"
			:show_add_module="false"
			:table_view="'lesson'"
			@setPageExistingModules="setPageExistingModules"
			@keyUpSearchExistingModules="keyUpSearchExistingModules">
			</table-view-course>
        </div>
        <div v-if="language_view">
            <div class="section-title">
            Languages
              <button @click="modalShow = !modalShow" class="ml-2 button buttton-small small-button">
                <img src="../../assets/images/icons/solid/plus_white.svg" width="14" />
                    new
            </button>
            </div>
        	<agency-tables  :table_info="''" :table_name="'languages'" :table_headers="['Language','Active in Nevvon', 'Active for Users']" :table_body_data="languages_all"
            :pagination_section="false"
            @updateLanguageUser="updateLanguageUser"
            @updateLanguageSystem="updateLanguageSystem"
			></agency-tables>
        </div>
        <div v-if="category_view">
            <div class="section-title">
                TAGS
            </div>

            <b-container class="bv-example-row">
                <b-row>
                    <b-col>
                        <div class="sub-section-title">
                        Keywords
                            <button @click="open_new_keywords = !open_new_keywords" class="ml-2 button buttton-small small-button">
                                <img src="../../assets/images/icons/solid/plus_white.svg" width="14" />
                                    new
                            </button>
                        </div>
                        <div class="category_section">
                            <draggable v-model="keywords_list"  @change="updateCategories($event)">
                                <div v-for="(elem,index) in keywords_list" class="cursor-pointer" :key="elem.id">
                                    <div class="display_flex">
                                        <span class="margin-top-10">{{ index+1 }}: </span>
                                        <input class="mt-1 mb-1 no-border"  v-model="elem.name"  :disabled="!keywords_list[index].edit" />
                                        <b-button variant="outline-information" class="edit_save" @click="editCategory(index, elem)" :class="{'blue-color': elem.edit}">{{category_edit_button_text(elem)}}</b-button>
                                        <b-button variant="outline-danger" @click="openRemoveCategory(elem)">Remove</b-button>
                                    </div>
                                </div>
                            </draggable>
                        </div>

                        <div class="sub-section-title">
                        Skills
                            <button @click="open_new_skills = !open_new_skills" class="ml-2 button buttton-small small-button">
                                <img src="../../assets/images/icons/solid/plus_white.svg" width="14" />
                                    new
                            </button>
                        </div>
                        <div class="category_section">
                            <draggable v-model="skill_list"  @change="updateCategories($event)">
                                <div v-for="(elem,index) in skill_list" class="cursor-pointer" :key="elem.id">
                                    <div class="display_flex">
                                        <span class="margin-top-10">{{ index+1 }}: </span>
                                        <input class="mt-1 mb-1 no-border"  v-model="elem.name"  :disabled="!skill_list[index].edit" />
                                        <b-button variant="outline-information" class="edit_save" @click="editCategory(index, elem)" :class="{'blue-color': elem.edit}">{{category_edit_button_text(elem)}}</b-button>
                                        <b-button variant="outline-danger" @click="openRemoveCategory(elem)">Remove</b-button>
                                    </div>
                                </div>
                            </draggable>
                        </div>

                        <div class="sub-section-title">
                        Associated Requirements
                            <button @click="open_new_assoc_reqs = !open_new_assoc_reqs" class="ml-2 button buttton-small small-button">
                                <img src="../../assets/images/icons/solid/plus_white.svg" width="14" />
                                    new
                            </button>
                        </div>
                        <div class="category_section">
                            <draggable v-model="assoc_req_list"  @change="updateCategories($event)">
                                <div v-for="(elem,index) in assoc_req_list" class="cursor-pointer" :key="elem.id">
                                    <div class="display_flex">
                                        <span class="margin-top-10">{{ index+1 }}: </span>
                                        <input class="mt-1 mb-1 no-border"  v-model="elem.name"  :disabled="!assoc_req_list[index].edit" />
                                        <b-button variant="outline-information" class="edit_save" @click="editCategory(index, elem)" :class="{'blue-color': elem.edit}">{{category_edit_button_text(elem)}}</b-button>
                                        <b-button variant="outline-danger" @click="openRemoveCategory(elem)">Remove</b-button>
                                    </div>
                                </div>
                            </draggable>
                        </div>
                    </b-col>
                    <b-col>
                        <div class="sub-section-title">
                        Disciplines
                            <button @click="open_new_disciplines = !open_new_disciplines" class="ml-2 button buttton-small small-button">
                                <img src="../../assets/images/icons/solid/plus_white.svg" width="14" />
                                    new
                            </button>
                        </div>
                        <div class="category_section">
                            <draggable v-model="discipline_list"  @change="updateCategories($event)">
                                <div v-for="(elem,index) in discipline_list" class="cursor-pointer" :key="elem.id">
                                    <div class="display_flex">
                                        <span class="margin-top-10">{{ index+1 }}: </span>
                                        <input class="mt-1 mb-1 no-border"  v-model="elem.name"  :disabled="!discipline_list[index].edit" />
                                        <b-button variant="outline-information" class="edit_save" @click="editCategory(index, elem)" :class="{'blue-color': elem.edit}">{{category_edit_button_text(elem)}}</b-button>
                                        <b-button variant="outline-danger" @click="openRemoveCategory(elem)">Remove</b-button>
                                    </div>
                                </div>
                            </draggable>
                        </div>

                        <div class="sub-section-title">
                        Locations
                            <button @click="open_new_locations = !open_new_locations" class="ml-2 button buttton-small small-button">
                                <img src="../../assets/images/icons/solid/plus_white.svg" width="14" />
                                    new
                            </button>
                        </div>
                        <div class="category_section">
                            <draggable v-model="location_list"  @change="updateCategories($event)">
                                <div v-for="(elem,index) in location_list" class="cursor-pointer" :key="elem.id">
                                    <div class="display_flex">
                                        <span class="margin-top-10">{{ index+1 }}: </span>
                                        <input class="mt-1 mb-1 no-border"  v-model="elem.name"  :disabled="!location_list[index].edit" />
                                        <b-button variant="outline-information" class="edit_save" @click="editCategory(index, elem)" :class="{'blue-color': elem.edit}">{{category_edit_button_text(elem)}}</b-button>
                                        <b-button variant="outline-danger" @click="openRemoveCategory(elem)">Remove</b-button>
                                    </div>
                                </div>
                            </draggable>
                        </div>
                    </b-col>
                </b-row>
            </b-container>
        </div>

    <sme-modals :show_duplicate_course="show_duplicate_course"
        :show_delete_course="show_delete_course"
        :course_to_duplicate="course_to_duplicate"
        :course_to_delete="course_to_delete"
        :module_duplicate="module_duplicate_view"
        @duplicateCourse="duplicateCourse"
        @deleteCourse="deleteCourse"
        @cleanModals="cleanModals"
        ></sme-modals>
    <div v-if="modalShow">
  
          <b-modal @ok="closeLanguageModal" ok-only ok-title="close" v-model="modalShow"  hide-header no-close-on-esc>
              <div class="input-content">
                    <input class="input-course-title" placeholder="Search Language..." v-model="language_search"/>
                    <table class="table table-bordered mt-2">
                          <thead>
                            <tr>
                                <!-- <th>Language</th> -->
                            </tr>
                        </thead>
                        <tbody>
			        	<tr v-for="(item,index) in add_language_list[0]" :key="index">
                            <td>{{item.name}}</td>
                           
                            <td valign="middle" class="justify-content-center align-middle">
                            <div class="button m-auto circle-button green-button" @click="updateLanguageSystem({language:item, index:index}, false)"
                                    v-if="item.available_in_system == 0">
                                <img width="15" src="../../assets/images/icons/solid/plus_white.svg">
                            </div>
                            <div class="button m-auto circle-button green2-content" v-else>
                                <img width="15" src="../../assets/images/icons/solid/check_white.svg">
                            </div>
                        </td>
                        </tr>
                        </tbody>
                      </table>
                    
                </div>

          </b-modal>
    </div>

    <div v-if="open_new_keywords">
      <b-modal v-model="open_new_keywords" id="modal-sm" size="sm" title="Create Keyword" ok-title="Create" @cancel="closeCategoryModal" @ok="addNewCategory(1)" :ok-disabled="!category_add_enabled || selected_category_ ==''">
        <div>
            <div>
                 <input type="text" class="border-bottom" v-model="selected_category_" @input="searchCategory($event)" />
            </div>

            <span v-if="!category_add_enabled" class="float-right mt-2 input-error-modal">Use a unique name</span>
        </div>
      </b-modal>
    </div>

    <div v-if="open_new_skills">
      <b-modal v-model="open_new_skills" id="modal-sm" size="sm" title="Create Skill" ok-title="Create" @cancel="closeCategoryModal" @ok="addNewCategory(2)" :ok-disabled="!category_add_enabled || selected_category_ ==''">
        <div>
            <div>
                 <input type="text" class="border-bottom" v-model="selected_category_" @input="searchCategory($event)" />
            </div>

            <span v-if="!category_add_enabled" class="float-right mt-2 input-error-modal">Use a unique name</span>
        </div>
      </b-modal>
    </div>

    <div v-if="open_new_assoc_reqs">
      <b-modal v-model="open_new_assoc_reqs" id="modal-sm" size="sm" title="Create assoc_req" ok-title="Create" @cancel="closeCategoryModal" @ok="addNewCategory(5)" :ok-disabled="!category_add_enabled || selected_category_ ==''">
        <div>
            <div>
                 <input type="text" class="border-bottom" v-model="selected_category_" @input="searchCategory($event)" />
            </div>

            <span v-if="!category_add_enabled" class="float-right mt-2 input-error-modal">Use a unique name</span>
        </div>
      </b-modal>
    </div>

    <div v-if="open_new_disciplines">
      <b-modal v-model="open_new_disciplines" id="modal-sm" size="sm" title="Create Discipline" ok-title="Create" @cancel="closeCategoryModal" @ok="addNewCategory(3)" :ok-disabled="!category_add_enabled || selected_category_ ==''">
        <div>
            <div>
                 <input type="text" class="border-bottom" v-model="selected_category_" @input="searchCategory($event)" />
            </div>

            <span v-if="!category_add_enabled" class="float-right mt-2 input-error-modal">Use a unique name</span>
        </div>
      </b-modal>
    </div>

    <div v-if="open_new_locations">
      <b-modal v-model="open_new_locations" id="modal-sm" size="sm" title="Create Location" ok-title="Create" @cancel="closeCategoryModal" @ok="addNewCategory(4)" :ok-disabled="!category_add_enabled || selected_category_ ==''">
        <div>
            <div>
                 <input type="text" class="border-bottom" v-model="selected_category_" @input="searchCategory($event)" />
            </div>

            <span v-if="!category_add_enabled" class="float-right mt-2 input-error-modal">Use a unique name</span>
        </div>
      </b-modal>
    </div>

    <div v-if="remove_category">
        <b-modal v-model="remove_category" title="Remove Category" ok-title="Remove"
    cancel-title="Cancel" @cancel="remove_category = !remove_category" @ok="removeCategory"
    >
     <p  class="mb-2">
        {{category_to_remove.name}} will be removed from this module. Are you sure you want to continue?
     </p>
    </b-modal>

</div>
</div>
    
</template>
<script>
import { EventBus } from './../../event_bus.js';
import LessonCreateView from './SharedViews/LessonCreateView'
export default {
    components : {
        LessonCreateView
    },
    computed : {
        program_view(){
            return this.$route.params.section == 'Programs'
        },
        module_view(){
            return this.$route.params.section == 'Modules'
        },
        lesson_view(){
            return this.$route.params.section == 'Lessons'
        },
        language_view(){
            return this.$route.params.section == 'Languages'
        },
        category_view(){
            return this.$route.params.section == 'Categories'
        }
    },
    data: function(){
        return{
            module_duplicate_view: false,
            hide_tab: false,
            language_search:'',
            modalShow:false,
            courses:'',
             pagination_existing_modules : {
                current_page : 0,
                total : 0,
                per_page : 0,
                from : 0,
                to : 0
			},
             pagination_existing_courses : {
                current_page : 0,
                total : 0,
                per_page : 10,
                from : 0,
                to : 0
			},
            timeout_input_existing_modules : null,
            existing_modules : [],
            existing_lessons : [],
            pagination_existing_lessons : {
                current_page : 0,
                total : 0,
                per_page : 0,
                from : 0,
                to : 0
			},
            show_duplicate_course:false,
            show_delete_course:false,
            course_to_duplicate:'',
            course_to_delete:'',
            course_search_key:'',
            languages_all:'',
            add_language_list:[],
            category_list:[],
            keywords_list:[],
            skill_list:[],
            assoc_req_list:[],
            discipline_list:[],
            location_list:[],
            open_new_keywords: false,
            open_new_skills: false,
            open_new_assoc_reqs: false,
            open_new_disciplines: false,
            open_new_locations: false,
            category_search:'',
            selected_category_:'',
            category_add_enabled: false,
            remove_category: false,
            category_to_remove:'',
        }
    },
    watch:{
        language_search: function(val){
            if(val == ''){
                return
            }
            var params={
                filters : {
                    search:val
                }
            }
            this.$store.dispatch('SMELanguageSearch', params).then((res =>{
                this.add_language_list = []
                this.add_language_list.push(res.data.data)
            }))
        },
        '$route.params.section': {
            handler: function(section) {
                if(section == 'Programs'){
                    EventBus.$emit('reset_seach_key')
                    this.getCourses();
                }
                else if(section == 'Modules'){
                    EventBus.$emit('reset_seach_key_module')
                    this.getExistingModules()
                }
                else if(section == 'Lessons'){
                    EventBus.$emit('reset_seach_key_module')
                    this.getExistingLessons()
                }
                else if(section == 'Languages'){
                    this.getExistingLanguages()
                }
                else if(section == 'Categories'){
                 this.getCategories()
                }
            },
            deep: true,
            immediate: true
        }
    },
    created : function(){

    },
    methods : {
        moveProgramTab(param){
            this.hide_tab = false
            this.$router.push({ name :'sme.dashboard' })
        },
        category_edit_button_text(category){
            if(category.edit){
                return 'Save'
            }else{
                return 'Edit'
            }
        },
        closeCategoryModal(){ 
            this.category_search = ''
            this.open_new_keywords = false
            this.open_new_skills = false
            this.open_new_assoc_req = false
            this.open_new_disciplines = false
            this.open_new_locations = false
            this.category_add_enabled = false
        },
        editCategory: function(index, elem){
            if(this.category_edit_button_text(elem) == 'Save'){
                var params = {
                    id: elem.id,
                    name: elem.name,
                    description: elem.description,
                    order: elem.order,
                    sme_tag_type_id: elem.sme_tag_type_id
                }
                this.$store.dispatch('updateCategory', params).then((res)=>{{ 
                    //this.getCategories()
                }
                }).catch((error) => {
                    console.log(error)
                })
            }
            
            if(elem.sme_tag_type_id == 1){
                this.keywords_list[index].edit = !this.keywords_list[index].edit
            }
            if(elem.sme_tag_type_id == 2){
                this.skill_list[index].edit = !this.skill_list[index].edit
            }
            if(elem.sme_tag_type_id == 3){
                this.discipline_list[index].edit = !this.discipline_list[index].edit
            }
            if(elem.sme_tag_type_id == 4){
                this.location_list[index].edit = !this.location_list[index].edit
            }
            if(elem.sme_tag_type_id == 5){
                this.assoc_req_list[index].edit = !this.assoc_req_list[index].edit
            }
        },
        removeCategory: function(){
            var params = {
                id: this.category_to_remove.id
            }
            this.$store.dispatch('deleteCategory', params).then((res)=>{{ 
                this.getCategories()
            }
            }).catch((error) => {
                console.log(error)
            })
        },
        addNewCategory: function(type){
            var params = {
                name: this.selected_category_,
                sme_tag_type_id: type
            }
            this.$store.dispatch('createCategory', params).then((res)=>{{ 
                this.getCategories()
            }
            }).catch((error) => {
                console.log(error)
            })
            this.selected_category_ = ''
            this.category_add_enabled = false
        },
        updateCategories: function(event){
            // console.log(event.moved.newInde)
            var params = {
                id: event.moved.element.id,
                filters : {
                     new_index: event.moved.newIndex + 1,
                     old_index: event.moved.oldIndex + 1,
                }
            }
            // this.$store.dispatch('updateCategoryOrder', params).then((res)=>{{ 
            //     //this.getCategories()
            // }
            // }).catch((error) => {
            //     console.log(error)
            // })

        },
        getCategories: function(){
            var params = {
            }
            this.$store.dispatch('getCategories', params).then((res)=>{{ 
                this.keywords_list.splice(0);
                this.skill_list.splice(0);
                this.discipline_list.splice(0);
                this.location_list.splice(0);
                this.assoc_req_list.splice(0);

                res.data.data.forEach(elem => elem.edit = false)
                this.category_list = res.data.data.sort((a,b) => a.order - b.order)
                this.category_list.forEach(category => {
                    if (category.sme_tag_type_id == 1) {
                        this.keywords_list.push(category);
                    } else if (category.sme_tag_type_id == 2) {
                        this.skill_list.push(category);
                    } else if (category.sme_tag_type_id == 3) {
                        this.discipline_list.push(category);
                    } else if (category.sme_tag_type_id == 4) {
                        this.location_list.push(category);
                    } else if (category.sme_tag_type_id == 5) {
                        this.assoc_req_list.push(category);
                    }
                });}
            }).catch((error) => {
                console.log(error)
            })
        },
        closeLanguageModal: function(){
            this.language_search = ''
            this.add_language_list = []
        },
        searchCategory(){
           this.checkCategoryMatch(this.selected_category_, 'category_add_enabled')
        
        },
        checkCategoryMatch(name, condition){
            if (this.category_list.filter(function(e) { return e.name === name; }).length > 0) {
                this[condition] = false
            }else{
               this[condition] = true
            }
        },
        openRemoveCategory : function(elem){
            this.remove_category = true

            this.category_to_remove = elem
        },
        updateLanguageSystem: function(obj){
             var params = {
                    id: obj.language[0].id,
                    status: (obj.language.available_in_system == 0) ? 'enable' : 'disable'
            }
             this.$store.dispatch('SMELanguageAvailabilty', params).then((res)=>{{ 
                 if('table' in obj){
                     console.log(obj)
                     this.languages_all[obj.index].available_in_system = res.data.available_in_system
                 }else{
                     this.add_language_list[0][obj.index].available_in_system = res.data.available_in_system
                 }
                this.getExistingLanguages();
            }
            }).catch((error) => {
                console.log(error)
                event.value = !event.value
            })
        },
        updateLanguageUser: function(obj){
            this.languages_all[obj.index].available_for_users = obj.language.available_for_users

        },
        getExistingLanguages: function(){
            var params = {
                filters:{
                 available_in_system: 1
                }
             };

            this.$store.dispatch("getLanguages", params).then(res => {
                this.languages_all = res.data.data;
                let temp_less = [];
                for (let i in this.languages_all) {
                    if (
                    this.languages_all[i].available_in_system == 1
                    ) {
                    temp_less.push(this.languages_all[i]);
                    }
                }
                this.languages_all = temp_less
            });

        },
        getCourses : function(key_search){
            var params = {
                filters : {
                    full:true,
                    page : this.pagination_existing_courses.current_page,
                    search : this.course_search_key,
                    per_page: this.pagination_existing_courses.per_page
                }
            }
            this.$store.dispatch('getCourses', params).then((res) => {
                this.courses = res.data.data;
                this.pagination_existing_courses = res.data.meta;
                this.pagination_existing_courses.per_page = 10

            }).catch((error) => {
                console.log(error);
            });
        },
        setPageExistingCourses: function(obj){
            setTimeout( () => {
                this.pagination_existing_courses.current_page = obj.page;
                this.course_search_key = obj.search;
                this.getCourses();

            },1000)
           

        },
        searchCourses : function(key_search){
            setTimeout( () => {
                if(key_search != this.course_search_key){
                    this.course_search_key = key_search;
                    this.getCourses();
                }
                
            },1000)
           
            
        },
        getExistingModules : function(search){
            var params = { 
                filters : { 
                    full : true, 
                    // in_course : this.id,
                    page : this.pagination_existing_modules.current_page,
                    search : search || '',
                    include_archived: 0,
                    page_loading: false,
                }
            }
            this.$store.dispatch('getModules', params).then((res) => {
                console.log(res);
                this.existing_modules = res.data.data;
                this.pagination_existing_modules = res.data.meta;
            });
		},
        setPageExistingModules : function(obj){
            if(this.module_view){
                this.pagination_existing_modules.current_page = obj.page;

                this.getExistingModules(obj.search);
            }
            if(this.language_view){
                this.pagination_existing_lessons.current_page = obj.page;
                this.getExistingLessons();
            }
       
		},
        getExistingLessons : function(search){
            console.log(search)
            var params = {
                filters : {
                    // in_module : this.current_module.id,
                    page : this.pagination_existing_lessons.current_page,
                    search : search || '',
                    include_archived: 0

                }
            }
            this.$store.dispatch('getLessons', params).then((res) => {
                this.existing_lessons = res.data.data;

                this.pagination_existing_lessons = res.data.meta;
            });
		},
        keyUpSearchExistingModules : function(key_word){
            clearTimeout(this.timeout_input_existing_modules);

            this.timeout_input_existing_modules = setTimeout( () => {
                if(this.module_view){
                    this.pagination_existing_modules.current_page = this.page;
                    this.getExistingModules(key_word);
                }
                if(this.lesson_view){
                    this.pagination_existing_lessons.current_page = this.page;
                    this.getExistingLessons(key_word);
                }
               
            }, 500)
		},
        showModalDelete : function(course){
            this.course_to_delete = course;
            this.show_delete_course = true;
        },

        deleteCourse : function(){
            this.show_delete_course = false
            this.course_to_delete = null;
            this.getCourses();
        },

        showModalDuplicate : function(course, module_view){
            this.module_duplicate_view = module_view
            this.course_to_duplicate = course;
            this.show_duplicate_course = true;
        },

        duplicateCourse : function(){
            this.course_to_duplicate = null
            this.show_duplicate_course = false
        },
        cleanModals(){
            this.show_duplicate_course = false
            this.show_delete_course = false
            this.module_duplicate = false
            this.course_to_duplicate = ''
            this.course_to_delete = ''
        }
    }

}
</script>
<style scoped>
.deneme{
    margin-top: 0px !important;
}
.category_section{
    margin-left: 1%;
    margin-right: auto;
    width:400px;
    margin-bottom: 2rem;
}
.margin-20{
    margin-left: 23%;
}
.no-border{
    border-top: none;
    border-left: none;
    border-right: none;
    border-radius: 4px;
    border-bottom: none;
}
.border-bottom{
    width: 100%;
    border-top: none;
    border-left: none;
    border-right: none;
    border-radius: 4px;
}
.display_flex{
    display: flex;
    flex-flow: row;
    gap: 8px 20px;
    height: 34px;
    margin-top: 8px;

   
}
.display_flex :first-child {
    width: 20px;
}
.display_flex :second-child {
     flex: 2 1 0;
}
.edit_save{
    width:50px !important;
}
.blue-color{
    color:#007bff;
}
.margin-top-10{
    margin-top: 10px !important;
}
.input-error-modal{
    font-size: 12px;
    color: red;
}
>>>.nav-tabs .nav-link.active, .nav-tabs .nav-item.show .nav-link {
    color:#11a5a7;
}
.active-tab-hide > .tab-content > .active{
    display: none;
}


</style>



// WEBPACK FOOTER //
// src/components/sme/SMEMainView.vue